export default __webpack_public_path__ + "static/media/pods.72bb142b.gif";